export default "__VITE_ASSET__DlPB$Ikt__"